import React from 'react';
import { GOOGLE_AUTH } from 'constants/routes';
import { apiUrl, appUrl } from 'constants/const';
import { ReactComponent as GoogleIcon } from '../../images/google_btn_icon.svg';
import { useTranslation } from 'react-i18next';

const LoginWithGoogle = () => {
  const { t } = useTranslation();

  return (
    <div className="d-flex flex-column justify-content-center align-items-center sign-in-with-google-wrapper">
      <a
        href={`${apiUrl}${GOOGLE_AUTH}?redirect_url=${appUrl}`}
        rel="noreferrer"
        className="text-decoration-none w-100"
        style={{ padding: '0 18px' }}
      >
        <div className="d-flex justify-content-center align-items-center button-container border-radius-button google-button-container w-100">
          <div className="d-flex justify-content-center align-items-center google-icon-container">
            <GoogleIcon style={{ width: '19px', height: '19px' }} />
          </div>
          <span className="mx-2 button-text font-weight-bold 'text-dark">{t('google_sign')}</span>
        </div>
      </a>
      <div className="sign-up-text-container text-lightPurple">
        <span className="sign-up-text">{t('or')}</span>
      </div>
    </div>
  );
};

export default LoginWithGoogle;
